export const adultContentTags = ['sexually-explicit', 'medically-gruesome'];
